export const DOCUMENT_STATUS = {
  draft: {
    key: 'draft',
    label: 'Draft',
    labelLangKey: 'status.draft',
    color: '#898989',
  },
  pending: {
    key: 'pending',
    label: 'Pending',
    labelLangKey: 'status.pending',
    color: '#FFA500',
  },
  completed: {
    key: 'completed',
    label: 'Completed',
    labelLangKey: 'status.completed',
    color: '#5AC463',
  },
  created: {
    key: 'created',
    label: 'Created',
    labelLangKey: 'status.created',
    color: '#5AC463',
  },
  cancelled: {
    key: 'cancelled',
    label: 'Cancelled',
    labelLangKey: 'status.cancelled',
    color: '#B41212',
  },
  send: {
    key: 'send',
    label: 'Send',
    labelLangKey: 'status.send',
    color: '#0077C7',
  },
  awaitingResponse: {
    key: 'awaitingResponse',
    label: 'Awaiting Response',
    labelLangKey: 'status.awaitingResponse',
    color: '#F79009',
  },
  accepted: {
    key: 'accepted',
    label: 'Accepted',
    labelLangKey: 'status.accepted',
    color: '#0077C7',
  },
};
